import {useCallback} from 'react';
import {IntersectionObserver} from '@/components/common';
import {LoanListItem} from '@/components/organisms';
import {ILoanInfo, ILoanItem} from '@/types';
import {useCommonParams, useDeviceId, useLoading} from '@/hooks';
import {clickEventHandler} from '@/helpers';
import {Wrapper} from '@/components/templates/collectLoanList/CollectLoanList.styled';
import {COMPONENT_TYPE} from '@/const';

const CollectLoanList = (props: ILoanInfo) => {
  const {ads = []} = props;
  const {mediaSeq, trackCd, page} = useCommonParams();
  const [deviceId] = useDeviceId();
  const [, setLoading] = useLoading();

  const handleClickLoan = useCallback(
    async (item: ILoanItem) => {
      await clickEventHandler({
        ...item,
        trackCd,
        setLoading,
        deviceId,
        mediaSeq,
        componentName: COMPONENT_TYPE.LOAN,
      });
    },
    [trackCd, setLoading, deviceId, mediaSeq],
  );

  const renderLoanList = (item: ILoanItem, index: number) => (
      !item.lcsBanner &&
      <IntersectionObserver key={`loan-item-${index}`} page={page} {...item} componentName={COMPONENT_TYPE.LOAN}>
          <LoanListItem  {...item} onClick={() => handleClickLoan(item)}/>
      </IntersectionObserver>
    )
  ;

  return (
    <Wrapper>
      {ads.length > 0 && ads.map((item: ILoanItem, index: number) => renderLoanList(item, index))}
    </Wrapper>
  );
};

export default CollectLoanList;
